export default __webpack_public_path__ + "static/media/profile.c62f8a5b.jpg";